import { SERVICE_URLS } from '@/app/_utils/select-api-service'

export const ACTIVATED_LOCATION_KEY = 'activated-location'
export const LOGIN_PAGE_BASE_PATH = `${SERVICE_URLS.pam}/accounts/login`
